import { render } from "./BrandedTextElement.vue.js?vue&type=template&id=b5dabfa0&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=template&id=b5dabfa0&scoped=true"
import script from "./BrandedTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=script&lang=js"
export * from "./BrandedTextElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=script&lang=js"

import "./BrandedTextElement.vue.scss?vue&type=style&index=0&id=b5dabfa0&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=style&index=0&id=b5dabfa0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5dabfa0"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedTextElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5dabfa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5dabfa0', __exports__)) {
    api.reload('b5dabfa0', __exports__)
  }
  
  module.hot.accept("./BrandedTextElement.vue.js?vue&type=template&id=b5dabfa0&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElement.vue?vue&type=template&id=b5dabfa0&scoped=true", () => {
    api.rerender('b5dabfa0', render)
  })

}


export default __exports__